module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ;  var classes = Util.clone(widget.styles);
classes.push(widget.baseClass) 
    ; __append("\n<div class=\"form ")
    ; __append(escapeFn( classes.join(' ') ))
    ; __append(" flex flex-column\">\n    <div name=\"form-header flex-none\" class=\"form-header\">\n        ")
    ;  if(widget.subtitleField&&widget.item&&(_.get(widget, widget.subtitleField))) { 
    ; __append("\n            <div class=\"subtitle\">\n                ")
    ; __append(escapeFn( _.get(widget, widget.subtitleField) ))
    ; __append("\n            </div>\n        ")
    ;  } 
    ; __append("\n        ")
    ;  if(widget.titleField || widget.title) { 
    ; __append("\n			")
    ;  if(widget.titleField) { 
    ; __append("\n				")
    ;  if(widget.titlePlaceHolder) { 
    ; __append("\n					<span class=\"control-title\">")
    ; __append(escapeFn( widget.titlePlaceHolder ))
    ; __append("</span>\n				")
    ;  } 
    ; __append("\n				<div class=\"title\">\n                    <div data-control-type=\"text\" data-control-target=\"")
    ; __append(escapeFn( widget.titleField ))
    ; __append("\"\n							")
    ;  if(widget.titlePlaceHolder) { 
    ; __append("\n						 		data-control-html-placeholder=\"Введите ")
    ; __append(escapeFn( widget.titlePlaceHolder ))
    ; __append("\"\n							")
    ;  } 
    ; __append(">\n                        ")
    ; __append(escapeFn( _.get(widget, widget.titleField) ))
    ; __append("\n                    </div>\n				</div>\n            ")
    ;  } else if(widget.title) { 
    ; __append(" \n				<div class=\"title\">\n						<div name=\"form-title\">")
    ; __append(escapeFn(widget.title ))
    ; __append("</div>\n				</div>\n			")
    ;  } 
    ; __append("\n        ")
    ;  } 
    ; __append("\n    </div>\n\n    <div name=\"form-body\" class=\"light-form-body _flex-item\"></div>\n\n    <div name=\"form-controls\" class=\"form-controls flex-none\"></div>\n\n    ")
    ;  if (widget.showCloseBtn) { 
    ; __append("\n    	<span class=\"i-close\" on-click=\"onCloseClick\"></span>\n	")
    ;  } 
    ; __append("\n	")
    ;  if (widget.showBackBtn) { 
    ; __append("\n    	<span class=\"i-back\" on-click=\"onCloseClick\"></span>\n    ")
    ;  } 
    ; __append("\n\n    <div class=\"overlay-loader\" name=\"overlay-loader\" style=\"display: none;\"></div>\n</div>\n")
  }
  return __output.join("");

}